import axios from 'axios'
import { envConfig } from '@const/env'
import { Validate } from '@utils/index'
import { Loading, Message } from 'element-ui'

let MCLoadingToast
function MC() {
  var env = envConfig()
  let baseURL =
    process.env.NODE_ENV == 'development' ? env.PROXY_HOST : env.HOST
  if (env.BASE_API != '/') {
    baseURL = `${baseURL}${env.BASE_API}/`
  } else {
    baseURL = `${baseURL}/`
  }

  this.mcIndex = 0
  this.pendingList = []
  this.isLoading = false
  this.CancelToken = axios.CancelToken
  this.axiosInstance = axios.create({
    baseURL,
    envMode: env.Mode,
    timeout: 15000,
    responseType: 'json',
    withCredentials: false,
    retry: 2,
    retryDelay: 1000
  })
  this.requestInterceptors()
  this.responseInterceptors()
}

MC.prototype.requestInterceptors = function () {
  this.axiosInstance.interceptors.request.use(
    (config) => {
      // 在发送请求之前做些什么
      if (!window.navigator.onLine) {
        // 未联网情况下
        throw 'navigatorOutLine'
      }
      let pendingItem = this.pendingList.find(
        (f) => f.pendingUrl === config.pendingUrl
      )

      if (
        !this.isLoading &&
        !Validate.isEmpty(pendingItem) &&
        pendingItem.headers.showLoading
      ) {
        showLayoutLoading()
        this.isLoading = true
      }
      return config
    },
    (err) => {
      // 对请求错误做些什么
      console.log(err)
    }
  )
}

MC.prototype.responseInterceptors = function () {
  this.axiosInstance.interceptors.response.use(
    (res) => {
      this.updateMCLoading()
      let response = res.data
      let pendingItem = this.pendingList.find(
        (f) => f.pendingUrl === res.config.pendingUrl
      )
      var { isStateError, isPrefer } = pendingItem.headers
      const { data, message, code } = response

      if (isPrefer) {
        return Promise.resolve(response)
      }

      if (isStateError) {
        if (['CM000000'].includes(code)) {
          return Promise.resolve(data)
        } else {
          if (message) {
            Message({ message: message, type: 'error', duration: 1500 })
          }
          return Promise.reject(data)
        }
      } else {
        if (['CM000000'].includes(code)) {
          return Promise.resolve(data)
        } else {
          return Promise.reject(response)
        }
      }
    },
    (error) => {
      // 对响应错误做点什么
      if (error === 'navigatorOutLine') {
        Message({
          message: '您的网络已断开，请稍后再试！',
          type: 'error',
          duration: 1500
        })
        this.removePendingList()
      } else if (error && error.message === 'cancelToken') {
        // cancelToken通用的途径
        this.updateMCLoading()
        this.removePendingList()
        return Promise.reject(error.message)
      } else {
        this.updateMCLoading()
        return Promise.reject(
          error.message || JSON.stringify(error) || '连接失败'
        )
      }
    }
  )
}

function requestHeader(preHeaders) {
  // 在主类里面的参数已赋值
  // let opt = this.options;
  let headers = Object.assign({}, preHeaders)
  // 接口有错误码，则返回完整数据自行处理异常逻辑。
  // 在catch里获取完成数据
  if (headers['isStateError'] === undefined) {
    headers['isStateError'] = true
  }
  // 将接口数据完整返回自行处理数据
  // 在then方法获取数据
  if (headers['isPrefer'] === undefined) {
    headers['isPrefer'] = false
  }
  // 是否显示全局loading
  if (headers['showLoading'] === undefined) {
    headers['showLoading'] = true
  }
  // 是否toast报错信息
  if (headers['toastErrorMsg'] === undefined) {
    headers['toastErrorMsg'] = true
  }
  // 添加环境版本
  if (headers['envMode'] === undefined) {
    headers['envMode'] = process.env.RUNTIME_ENV.toUpperCase()
    //20230811改动点：默认是测试-STG，灰度-PRE、生产-PROD
    if (headers['envMode'] != 'PROD' && headers['envMode'] != 'PRE') {
      headers['envMode'] = 'STG'
    }
  }
  // app版本号和资源版本号
  headers['version'] = '1.0.0'
  return headers
}

MC.prototype.MCRequestChangeStatus = function () {
  this.pendingList.forEach((pendingItem) => {
    if (['pending', 'finished'].includes(pendingItem.status)) return
    let fullParams = pendingItem.params

    // 调用接口时的参数
    let pendingItemParams
    let fullParamsStr = JSON.stringify(fullParams)

    switch (pendingItem.mcType) {
      case 'postJson':
        pendingItemParams = fullParams
        break
      case 'getJson':
        pendingItemParams = fullParams
        break
      default:
        pendingItemParams = new URLSearchParams({ reqData: fullParamsStr }) // 对参数进行了编码
    }
    pendingItem.status = 'pending'
    if (pendingItem.mcType == 'getJson') {
      pendingItem.axiosInstance
        .get(
          pendingItem.url,
          Object.assign(
            {
              params: fullParams
            },
            (() => {
              let config = pendingItem.config
              if (
                config.cancelToken &&
                config.cancelToken instanceof this.CancelToken
              ) {
                // 业务代码中传入的cancelToken，优化处理pendingList
                let cancelToken = config.cancelToken
                cancelToken.throwIfRequested = () => {
                  if (cancelToken.reason) {
                    // 业务代码中自己cancle了，处理以下逻辑
                    this.changePendingItem(pendingItem, 'finished')
                    throw cancelToken.reason
                  }
                }
                pendingItem.cancel = () => {
                  pendingItem.status = 'finished'
                  // MC中cancle了，中断请求，业务中获取公共cancle信息
                  cancelToken.reason = 'cancelToken'
                }
              } else {
                config.cancelToken = new this.CancelToken((cancel) => {
                  pendingItem.cancel = cancel
                })
              }
              config.pendingUrl = pendingItem.pendingUrl
              return config
            })()
          )
        )
        .then((data) => {
          this.changePendingItem(pendingItem, 'finished')
          pendingItem.resolve(data)
          this.updateMCLoading()
        })
        .catch((error) => {
          this.changePendingItem(pendingItem, 'finished')
          pendingItem.reject(error)
          this.updateMCLoading()
        })
      return
    }
    pendingItem.axiosInstance
      .post(
        pendingItem.url,
        pendingItemParams,
        (() => {
          let config = pendingItem.config
          if (
            config.cancelToken &&
            config.cancelToken instanceof this.CancelToken
          ) {
            // 业务代码中传入的cancelToken，优化处理pendingList
            let cancelToken = config.cancelToken
            cancelToken.throwIfRequested = () => {
              if (cancelToken.reason) {
                // 业务代码中自己cancle了，处理以下逻辑
                this.changePendingItem(pendingItem, 'finished')
                throw cancelToken.reason
              }
            }
            pendingItem.cancel = () => {
              pendingItem.status = 'finished'
              // MC中cancle了，中断请求，业务中获取公共cancle信息
              cancelToken.reason = 'cancelToken'
            }
          } else {
            config.cancelToken = new this.CancelToken((cancel) => {
              pendingItem.cancel = cancel
            })
          }
          config.pendingUrl = pendingItem.pendingUrl
          return config
        })()
      )
      .then((data) => {
        this.changePendingItem(pendingItem, 'finished')
        pendingItem.resolve(data)
        this.updateMCLoading()
      })
      .catch((error) => {
        this.changePendingItem(pendingItem, 'finished')
        pendingItem.reject(error)
        this.updateMCLoading()
      })
  })
}

MC.prototype.postForm = function (url, params = {}, config, mcType) {
  config = config || { headers: {} }
  let headers = requestHeader(config.headers)
  return new Promise((resolve, reject) => {
    let pendingUrl = `${++this.mcIndex}&${url}`
    this.pendingList.push({
      pendingUrl,
      url,
      params,
      mcType,
      config,
      resolve,
      reject,
      headers,
      status: 'preparative',
      axiosInstance: this.axiosInstance
    })
    this.MCRequestChangeStatus()
  })
}

/**
 * 请求接口：postJson
 * @param {*} url 接口地址
 * @param {*} params 接口参数
 */
MC.prototype.postJson = function (url, params, config) {
  return this.postForm(url, params, config, 'postJson')
}

MC.prototype.getJson = function (url, params, config) {
  return this.postForm(url, params, config, 'getJson')
}

MC.prototype.changePendingItem = function (pendingItem, status) {
  let index
  switch (status) {
    case 'finished':
      // 删除
      index = this.pendingList.findIndex((f) => f === pendingItem)
      ~index && this.pendingList.splice(index, 1)
      break
    default:
      pendingItem.status = 'pending'
  }
}

/**
 * 清理已加入pendingList的请求
 */
MC.prototype.removePendingList = function () {
  while (this.pendingList.length) {
    this.removePendingItem(this.pendingList.shift())
  }

  this.updateMCLoading()
}

/**
 * 注销单个请求
 * @param {pendingList.item} item 单个请求item
 */
MC.prototype.removePendingItem = function (item) {
  switch (item.status) {
    case 'preparative':
      item.reject('cancelToken')
      break
    case 'pending':
      item.cancel('cancelToken')
      break
  }
}

MC.prototype.updateMCLoading = function () {
  if (
    this.pendingList &&
    this.pendingList.some(
      (pendingItem) => pendingItem.headers && pendingItem.headers.showLoading
    )
  ) {
    // nothing
  } else {
    setTimeout(() => {
      this.isLoading = false
      closeLayoutLoading()
    }, 50)
  }
}

function showLayoutLoading() {
  MCLoadingToast = Loading.service({
    lock: true,
    customClass: 'globalLoading',
    target: document.getElementById('app')
  })
}

function closeLayoutLoading() {
  if (MCLoadingToast) {
    MCLoadingToast.close()
  }
}

export default {
  install(Vue) {
    Vue.$mc = Vue.prototype.$mc = new MC()
  }
}



// WEBPACK FOOTER //
// ./src/utils/request/mc.js